import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { observer } from 'mobx-react';
import { action } from 'mobx';
import Modal from 'components/Modal';
import { Dialog, DialogTitle, DialogContent } from 'components/Dialog';
import Icon from 'components/Icon';
import IconButton from 'components/IconButton';
import cx from 'classnames';
import styles from './DocumentModal.m.sass';
var views = {
  NewDocument: require('../../views/NewDocument/NewDocumentView').default,
  DocumentInspector: require('../../views/DocumentInspector/DocumentInspectorView').default
};
var DocumentModal = observer(_class = /*#__PURE__*/function (_React$Component) {
  function DocumentModal() {
    var _this;
    _classCallCheck(this, DocumentModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DocumentModal, [].concat(args));
    _this.changeTab = action(function (e, tab) {
      e.preventDefault();
      _this.props.documentStore.view.viewTab = tab;
    });
    _this.close = function () {
      return _this.props.documentStore.setView(null);
    };
    return _this;
  }
  _inherits(DocumentModal, _React$Component);
  return _createClass(DocumentModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var documentStore = this.props.documentStore;
      var view = documentStore.view;
      var viewOpen = Boolean(view);
      if (!viewOpen) {
        return null;
      }
      var _view$viewTabs = view.viewTabs,
        viewTabs = _view$viewTabs === void 0 ? [] : _view$viewTabs,
        viewTab = view.viewTab,
        viewType = view.viewType,
        viewTitle = view.viewTitle;
      var View = views[viewType];
      return /*#__PURE__*/React.createElement(Modal, {
        className: styles.modal,
        position: "top",
        isOpened: viewOpen,
        onRequestClose: this.close,
        hideOverlayDismiss: true
      }, /*#__PURE__*/React.createElement(Dialog, {
        className: styles.dialog
      }, /*#__PURE__*/React.createElement(DialogTitle, {
        className: styles.title
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.titleText
      }, /*#__PURE__*/React.createElement("h3", null, viewTitle),
      // Don't show the download link if the latest version is not
      // downloadable.
      view.document && view.document.latestVersion && !view.document.latestVersion.purged && view.document.latestVersion.downloadable && /*#__PURE__*/React.createElement("a", {
        onClick: function onClick(e) {
          return e.preventDefault() || view.download(view.document.latestVersion, view.document.latestVersion.files[0]);
        }
      }, "Download Latest")), /*#__PURE__*/React.createElement(IconButton, {
        onClick: this.close
      }, /*#__PURE__*/React.createElement(Icon, {
        material: true,
        name: "close"
      }))), /*#__PURE__*/React.createElement(DialogContent, {
        className: styles.content
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.tabs
      }, viewTabs.map(function (tab) {
        return /*#__PURE__*/React.createElement("a", {
          className: cx(styles.tab, viewTab === tab.id && styles.active),
          key: tab.id,
          onClick: function onClick(e) {
            return _this2.changeTab(e, tab.id);
          },
          title: tab.tooltip
        }, tab.title);
      })), /*#__PURE__*/React.createElement(View, {
        view: view,
        showTags: this.props.showTags
      }))));
    }
  }]);
}(React.Component)) || _class;
export { DocumentModal as default };
//# sourceMappingURL=index.js.map
